export async function lazyLoad() {
  return import('@cian/authentication-widget');
}
